<section class="section grey-900" *ngIf="discoverPanelData">
  <div class="section-container align-c">
    <h2 class="section-heading white mar-b-48 wid-75">
      {{ discoverPanelData?.title }}
    </h2>
    <div class="tabs-dark">
      <ng-container *ngIf="discoverPanelData && discoverPanelData.components && discoverPanelData.components.length > 1">
        <ng-container *ngFor="let tab of discoverPanelData.components">
          <label [class.active]="tab.active" (click)="selectTab(tab)">
            {{ tab.fields.title }}
          </label>
        </ng-container>
      </ng-container>
      <div
        class="tab-dark"
        [class.show]="tab.active"
        [class.active]="tab.active"
        *ngFor="let tab of discoverPanelData.components"
      >
        <div class="trusted-innovators">
          <div class="align-l">
            <div class="trusted-innovators-content" [innerHTML]="tab.fields.description | toHtml"></div>
            @if(tab?.fields?.name && tab?.fields?.designation){
              <div class="user-name-designation">{{ tab.fields.name }} - {{ tab.fields.designation }}</div>
            }
            <div class="mar-t-24" *ngIf="tab?.fields?.button">
              <a
                href="{{ tab?.fields?.button[0].fields.redirectLink | urlParams:queryParams}}"
                target="{{ tab?.fields?.button[0].fields.actionType }}"
                class="link-xl"
                >{{ tab.fields?.button[0].fields.buttonText
                }}<span class="arrow">&rarr;</span></a
              >
            </div>
          </div>
          <figure class="trusted-innovators-image">
            <img [src]="tab.fields.image.fields.file.url" alt="" />
          </figure>
        </div>
      </div>
    </div>
  </div>
</section>
<ng-container *ngIf="!hideTrustPilot">
  <app-trust-pilot
    [bgWhite]="bgWhite"
    [paddTop]="true"
  ></app-trust-pilot>
</ng-container>
